import styled from 'styled-components'
import { COLORS } from '../../constants'

export const Container = styled.div<{ $selected: boolean }>`
  display: flex;
  width: 95%;
  justify-content: space-between;
  align-item: center;
  height: auto;
  min-height: 5rem;
  background-color: ${({ $selected }) =>
    $selected ? COLORS.lightGreen : COLORS.background};
  margin-top: 1rem;
  padding: 0.5rem;
  border-radius: 5px;
  border: none;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    cursor: pointer;
    transform: scale(1.02);
  }

  &:active {
    transform: scale(0.98);
  }

  @media (max-width: 1200px) {
    width: 95%;
    min-height: 4rem;
    padding: 0.5rem;
  }
`

export const Div = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: auto;
  width: 90%;
  padding-left: 1rem;

  &:nth-child(1) {
    width: 70%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;

    p {
      font-size: 1rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
      position: relative;
      padding-left: 1.2rem;

      &::before {
        content: '•';
        position: absolute;
        left: 0;
        font-size: 1rem;
        line-height: 1.2rem;
      }

      &:hover {
        white-space: normal;
        overflow: visible;
        max-width: 100%;
      }
    }
    /* First paragraph styling */
    p:nth-of-type(1) {
      margin-bottom: 0.7rem;
    }

    /* Apply margin to second paragraph only when there are 3 p elements */
    p:nth-of-type(2):nth-last-of-type(2) {
      margin-bottom: 0.7rem;
    }
    span {
      font-weight: bold;
    }

    @media (max-width: 1200px) {
      p {
        font-size: 0.85rem;
        padding-left: 0.8rem;

        &::before {
          font-size: 0.85rem;
        }
      }
    }

    @media (max-width: 480px) {
      p {
        font-size: 0.75rem;

        &::before {
          font-size: 0.75rem;
        }
      }
    }
  }
`

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10%;

  @media (max-width: 1200px) {
    svg {
      width: 25px;
      height: 25px;
    }
  }

  @media (max-width: 480px) {
    svg {
      width: 20px;
      height: 20px;
    }
  }
`
